import { Typography } from '@snack-uikit/typography';
import cn from 'classnames';
import { ReactElement } from 'react';

import { Condition } from '@/components/static';
import { TABLE_CENTER_NAMES } from '@/constant/dynamic';
import { DATA_TEST_IDS_INJECTORS } from '@/constant/tests';
import { FindElementPredicate } from '@/types/ssr';
import { head, identity, isEmpty, isOneOf } from '@/utils/common';
import { removeEmptyStrings } from '@/utils/strings';

import {
  collectTextContent,
  findElements,
  isCaptionElement,
  isColElement,
  isTbodyElement,
  isTheadElement,
} from '../utils';
import s from './styles.module.scss';
import { getNodeClass, makeInjector, nodeNameIs } from './utils';

export const tableInjector = makeInjector((node, children) => {
  const isCenterCn = isOneOf(TABLE_CENTER_NAMES);

  const nodeClassName = getNodeClass(node);

  const cleanChildren = removeEmptyStrings(children);

  const getElementsForRender = (pred: FindElementPredicate, afterFind = identity<ReactElement[]>) =>
    removeEmptyStrings(afterFind(findElements(cleanChildren, pred)));

  const captionContent = collectTextContent(getElementsForRender(isCaptionElement));
  return (
    <div className={s.root_table_wrapper}>
      <table data-test-id={DATA_TEST_IDS_INJECTORS.table} className={s.table_wrapper}>
        <Condition when={!isEmpty(captionContent)}>
          <caption className={s.caption_wrapper}>
            <Typography.SansBodyM>{captionContent}</Typography.SansBodyM>
          </caption>
        </Condition>
        <colgroup> {getElementsForRender(isColElement)}</colgroup>
        <thead
          className={cn(s.table_head, {
            [s.table_head_center]: isCenterCn(nodeClassName),
          })}
        >
          {head(getElementsForRender(isTheadElement))?.props.children}
        </thead>
        <tbody
          className={cn(s.table_body, {
            [s.table_body_center]: isCenterCn(nodeClassName),
          })}
        >
          {head(getElementsForRender(isTbodyElement))?.props.children}
        </tbody>
      </table>
    </div>
  );
}, nodeNameIs('table'));
